import { createContext, useState } from 'react';
import api from 'services/api';

export const VasilhameSacariaContext = createContext();

export const VasilhameSacariaProvider = ({ children }) => {
  const [getLoading, setGetLoading] = useState(false);
  const [vasilhameSacaria, setVasilhameSacaria] = useState({
    data: [],
    colunas: [],
    order: { field: 'dtemissao', sort: 'desc' },
    filter: {},
    page: 0,
    size: 10,
  });

  const getVasilhameSacaria = async (payload) => {
    try {
      setGetLoading(true);
      const { data } = await api.post('/Grid', {
        filter: vasilhameSacaria?.filter,
        page: vasilhameSacaria?.page,
        size: vasilhameSacaria?.size,
        order: vasilhameSacaria?.order,
        ...payload,
      });
      setVasilhameSacaria((prev) => ({ ...prev, ...data, ...payload }));
    } catch (error) {
    } finally {
      setGetLoading(false);
    }
  };

  return (
    <VasilhameSacariaContext.Provider
      value={{ vasilhameSacaria, getLoading, getVasilhameSacaria }}
    >
      {children}
    </VasilhameSacariaContext.Provider>
  );
};
